export {
    AUTH_MESSAGE_LOCALE_METADATA_KEY,
    LOCALE_SNAPSHOT_SCHEMA_VERSION,
    buildAuthMessageLocaleMetadata,
    resolveAuthMessageLocale,
    resolveLocaleSnapshot,
} from './locales';

export type {
    LocaleSnapshotSource,
    LocaleSnapshotV1,
    ResolveLocaleSnapshotInput,
} from './locales';
